import { Injectable } from '@angular/core';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { shareReplay, map } from 'rxjs/operators';

import {
  SMALL_BREAKPOINT,
  LARGE_BREAKPOINT,
  MOBILE_BREAKPOINT,
  HUGE_BREAKPOINT,
} from './breakpoint-model';

@Injectable({
  providedIn: 'root',
})
export class BreakpointService {
  matches$ = this.breakpointObserver
    .observe([
      MOBILE_BREAKPOINT,
      SMALL_BREAKPOINT,
      LARGE_BREAKPOINT,
      HUGE_BREAKPOINT,
    ])
    .pipe(shareReplay({ bufferSize: 1, refCount: true }));

  mobileMatches$ = this.matches$.pipe(
    map((matches) => matches.breakpoints[MOBILE_BREAKPOINT])
  );

  constructor(private breakpointObserver: BreakpointObserver) {}

  mobileMatches(): boolean {
    return this.breakpointObserver.isMatched(MOBILE_BREAKPOINT);
  }

  smallMatches(): boolean {
    return this.breakpointObserver.isMatched(SMALL_BREAKPOINT);
  }

  largeMatches(): boolean {
    return this.breakpointObserver.isMatched(LARGE_BREAKPOINT);
  }

  getMatches(): Observable<BreakpointState> {
    return this.matches$;
  }
}
